import { FC, type JSX } from 'react';

import classes from './style.module.css';

interface InputDescriptionProps {
  message: string | JSX.Element;
  className?: string;
}

const defaultClassName = classes.inputDescription;

export const InputDescription: FC<InputDescriptionProps> = ({ message, className }) => (
  <span className={className || defaultClassName}>{message}</span>
);
